export const CHANGEQUERIESMANAGEMENT_FILE = 'CHANGEQUERIESMANAGEMENT_FILE';
// 更新
export const CHANGEQUERIESMANAGEMENT_UPDATE = 'CHANGEQUERIESMANAGEMENT_UPDATE';
